import React from 'react';
import theme from 'config/theme';

export const REPAIRS_KANBAN_CARD_INFO = [
  { key: 'vehicleDescription', label: 'Brand/Model', active: true },
  {
    key: 'dateToServicePoint',
    label: 'In Service',
    active: true,
    render: (card) => (
      <div style={{ color: theme.palette.grays.gray400, marginTop: '8px' }}>
        In Service: {card.dateToServicePoint}
      </div>
    ),
  },
  {
    key: 'outDateFromServicePoint',
    label: 'Out of Service',
    active: true,
    render: (card) => (
      <div style={{ color: theme.palette.grays.gray400 }}>
        Out of Service: {card.outDateFromServicePoint}
      </div>
    ),
  },
  {
    key: 'details',
    label: 'Details (Date)',
    active: true,
    group: 'cardFooter',
    render: (card) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '4px',
        }}
      >
        <span
          style={{
            color: theme.palette.grays.gray400,
            fontSize: '0.75rem',
          }}
        >
          Created at {card.createdAt}
        </span>
      </div>
    ),
  },
];
